/* A switch row from the v15 prototype (`.frow-sw`): the label and its caption at the left, the switch at the right.
   Pass as a Mantine Switch's `classNames` with `labelPosition="left"`. */
.root {
  min-height: 56px;
  padding: 10px 14px;
  background: #fff;
  border: 1px solid var(--bcs-border-control, var(--mantine-color-gray-4));
  border-radius: 8px;
  display: flex;
  align-items: center;

  &[data-disabled] {
    background: var(--bcs-gray-1, var(--mantine-color-gray-1));
  }
}

.body {
  flex: 1;
  align-items: center;
}

.labelWrapper {
  flex: 1;
}

.label {
  padding: 0;
  font-size: 15px;
  font-weight: 500;
  color: var(--bcs-gray-9, var(--mantine-color-gray-9));
}

.description {
  margin-top: 2px;
  padding: 0;
  font-size: 13px;
  line-height: 17px;
  color: var(--bcs-gray-7, var(--mantine-color-gray-7));
}
